import { SiJquery } from 'react-icons/si'

export const JQueryTech = () => {
    return (
        <div>
        <SiJquery />
        <h4>JQuery</h4>
        </div>
    )
}